import React from 'react'

export const EyeIcon = () => {
  return (
    <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg" className='eye-icon'>
      <path d="M9.99992 0.25C5.83325 0.25 2.27492 2.84167 0.833252 6.5C2.27492 10.1583 5.83325 12.75 9.99992 12.75C14.1666 12.75 17.7249 10.1583 19.1666 6.5C17.7249 2.84167 14.1666 0.25 9.99992 0.25ZM9.99992 10.6667C7.69992 10.6667 5.83325 8.8 5.83325 6.5C5.83325 4.2 7.69992 2.33333 9.99992 2.33333C12.2999 2.33333 14.1666 4.2 14.1666 6.5C14.1666 8.8 12.2999 10.6667 9.99992 10.6667ZM9.99992 4C8.61659 4 7.49992 5.11667 7.49992 6.5C7.49992 7.88333 8.61659 9 9.99992 9C11.3833 9 12.4999 7.88333 12.4999 6.5C12.4999 5.11667 11.3833 4 9.99992 4Z" fill="#4C4C4C"/>
    </svg>
  )
}